export function stringOrDefault(str: string | undefined, defaultVal: string = '') {
  return str ? str : defaultVal
}
